module.exports = __webpack_public_path__ + "img/02.4666abc8.jpg";